import { nanoid } from 'nanoid'

import { randomBytes } from './random'

/**
 * get a random 36 character long v4 UUID
 *
 * @returns {String}
 */
export function uuidv4(): string {
  if (typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }

  let id: string

  // https://stackoverflow.com/a/2117523
  try {
    id = `${1e7}-${1e3}-${4e3}-${8e3}-${1e11}`.replaceAll(/[018]/g, (c) =>
      (+c ^ (randomBytes(1)[0] & (15 >> (+c / 4)))).toString(16),
    )
  } catch {
    const url = URL.createObjectURL(new Blob([]))

    URL.revokeObjectURL(url)

    id = url.slice(-36)
  }

  return id
}

export const uuid = uuidv4

/**
 * Generate a unique id, 32 length
 *
 * @returns {String}
 */
export function guid(): string {
  return nanoid(32)
}
